import { queryDeleteLicensedConfiguration } from "../api/use-cases/query-delete-licensed-configuration";
import loadLicensedConfigurations from "./load-licensed-configurations";

const deleteLicensedConfiguration = async (
  configurationId: string,
): Promise<void> => {
  await queryDeleteLicensedConfiguration(configurationId);
  // after deleting the licenses configuration, we need to reload the licensed configurations
  await loadLicensedConfigurations();
};

export default deleteLicensedConfiguration;
